import BetterweWxApi from './api.js'
const control = new BetterweWxApi()
control.config()
export default control
